import { useContext, useMemo } from "react";
import { alpha, Typography } from "@mui/material";
import { parseMessageWithMentions, UserDirectoryContext } from "hhn-commons";
import { IMessageContentTypeBubble } from "../../MessagePanel";
import TextContentWrapper from "../../../common/TextContentWrapper";
import theme from "../../../theme";
import ExpandableText from "../../../common/ExpandableText";

const TextContent = ({ message }: IMessageContentTypeBubble) => {
  const messageData = message.getMessage();
  const { userDirectory } = useContext(UserDirectoryContext);

  const body = messageData.body ?? messageData.fallbackMessage ?? "";

  const segments = useMemo(() => {
    const getUserTitle = (userId: string): string | undefined => {
      try {
        const userInfo = userDirectory.getUserInfo(userId);
        return userInfo?.title;
      } catch {
        return undefined;
      }
    };

    return parseMessageWithMentions(
      body,
      messageData.mentionedUsers,
      getUserTitle,
    );
  }, [body, messageData.mentionedUsers, userDirectory]);

  // If no mentions, render simple text
  if (segments.length === 1 && !segments[0].isMention) {
    return (
      <TextContentWrapper>
        <ExpandableText>{body}</ExpandableText>
      </TextContentWrapper>
    );
  }

  // Render text with highlighted mentions
  return (
    <TextContentWrapper>
      <ExpandableText>
        {segments.map((segment, index) =>
          segment.isMention ? (
            <Typography
              key={index}
              variant="inherit"
              component="span"
              sx={{
                backgroundColor: alpha(theme.palette.primary.light, 0.5),
                borderRadius: "2px",
                px: 0.25,
              }}
            >
              {segment.text}
            </Typography>
          ) : (
            segment.text
          ),
        )}
      </ExpandableText>
    </TextContentWrapper>
  );
};

export default TextContent;
